var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    cx: 8.1,
    cy: 8.1,
    rx: 3.9,
    ry: 5.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF424C",
    d: "M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M9,13H7v-2h2V13z M10,8.4l-1,1V10H7V9 c0-0.3,0.1-0.5,0.3-0.7L8.6,7C8.8,6.7,9,6.4,9,6c0-0.6-0.4-1-1-1S7,5.4,7,6v1H5V6c0-1.7,1.3-3,3-3s3,1.3,3,3 C11,6.9,10.6,7.8,10,8.4L10,8.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.55935308364ca8481bd605b79e18dec7.svg";
export { ForwardRef as ReactComponent };